import { returnPath } from '~/features/common/utils/navigation/returnPath';


export const getIndexPath = returnPath("/admin/server-settings");